import { SubAccountType } from '../../../../models/subaccount-type';
import client from '../../client';

const subaccountGet = async (): Promise<SubAccountType[]> => {
  const { data } = await client.get<{ accounts: SubAccountType[] }>(
    '/subaccount/get'
  );

  return data.accounts;
};

export default subaccountGet;
